import { useContext, useEffect, useState } from 'react'
import { UserContext } from '../contexts/user-context'
import LoadingSpinner from '../components/ui/LoadingSpinner'
import ProfileHeader from '../components/Profile/ProfileHeader'
import ProfileForm from '../components/Profile/ProfileForm'
import EmailVerification from '../components/Profile/EmailVerification'
import UserPreferences from '../components/UserPreferences/UserPreferences';
import { LogoutButton } from '../components/Header/buttons/logout-button'
import VisibilityToggle from '../components/Buttons/ButtonVisibilityToggle'

export const ProfilePage = () => {
    const {
        user,
        ddUser,
        userProfileCompleted,
        emailVerified,
        isInitializing
    } = useContext(UserContext)
    const [showForm, setShowForm] = useState(false)
    const [showPreferences, setShowPreferences] = useState(false)

    const formSubmitCallback = (response) => {
        if (response.error) {
            console.error("Error submitting form: ", response.error)
            return
        }

        setShowForm(false)
    }

    useEffect(() => {
        if (!isInitializing && user && !ddUser && !userProfileCompleted) {
            setShowForm(true)
        }
    }, [userProfileCompleted, user, ddUser, isInitializing])

    return (
        <div
            style={{
                minHeight: 'calc(100vh - 100px)',
                marginBottom: '40px',
                width: '100%',
                maxWidth: 'calc(1280px + 2rem)',
                padding: '2rem',
                margin: '0 auto'
            }}
        >
            <h1>
                My Profile
            </h1>

            {!user || isInitializing ? (
                <LoadingSpinner />
            ) : (
                <div>

                    <div>
                        <ProfileHeader
                            user={user}
                            ddUser={ddUser}
                            emailVerified={emailVerified}
                        />

                        {!emailVerified && <EmailVerification />}

                        {ddUser && !userProfileCompleted ? (
                            <p>
                                Please complete your profile to access all features.
                            </p>
                        ) : (
                            <VisibilityToggle
                                showElement={showForm}
                                setShowElement={setShowForm}
                                textVisible="Cancel"
                                textHidden="Edit Profile"
                            />
                        )}

                        {!isInitializing && showForm && (
                            <div className={`spc-p-1 spc-m-t-2 border-gray bg-light-green`}>
                            <ProfileForm onFormSubmit={formSubmitCallback} />
                            </div>
                        )}

                        <div className="spc-m-t-1">
                            <VisibilityToggle
                                showElement={showPreferences}
                                setShowElement={setShowPreferences}
                                textVisible="Close Preferences"
                                textHidden="Edit Preferences"
                            />

                            {!isInitializing && showPreferences && <UserPreferences />}
                        </div>
                    </div>

                    <hr style={{margin: '2rem 0'}} />

                    <div>
                        <LogoutButton />
                    </div>
                </div>
            )}
        </div>
    )
}
